<template>
  <div class="crt">
    <div class="container">

      <header>
        <span class="prompt">&gt; </span><h1>aryeh greenberg</h1><span class="cursor">_</span>
      </header>

      <p class="tagline">software engineer &amp; private pilot &amp; scuba diver &amp; explorer</p>

      <section class="block">
        <h2>// about</h2>
        <p>Focused on Solidity, EVM development, and confidential computation.<br>
        When not writing contracts — usually in the air or underwater.</p>
      </section>

      <section class="block">
        <h2>// work</h2>
        <div v-for="(project, i) in projects" :key="i" class="project-row">
          <span class="idx">{{ String(i + 1).padStart(2, '0') }}.</span>
          <span class="proj-name">{{ project.title }}</span>
          <span class="dots" aria-hidden="true"></span>
          <a v-if="project.link" :href="project.link" target="_blank" rel="noopener noreferrer" class="proj-link">{{ project.label }} ↗</a>
          <span v-else class="proj-link dim">—</span>
        </div>
      </section>

      <section class="block">
        <h2>// contact</h2>
        <div class="links">
          <a href="mailto:aryeh@aryehgreenberg.com">email</a>
          <span class="sep"> / </span>
          <a href="https://x.com/aryeh_greenberg" target="_blank" rel="noopener noreferrer">twitter</a>
          <span class="sep"> / </span>
          <a href="https://linkedin.com/in/aryeh-greenberg" target="_blank" rel="noopener noreferrer">linkedin</a>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
export default {
  name: "PersonalLanding",
  data() {
    return {
      projects: [
        {
          title: "OpenZeppelin Contracts",
          link: "https://github.com/OpenZeppelin/openzeppelin-contracts",
          label: "github"
        },
        {
          title: "ERC-7984: Confidential Tokens",
          link: "https://eips.ethereum.org/EIPS/eip-7984",
          label: "erc"
        },
        {
          title: "Comp.Vote",
          link: "https://comp.vote",
          label: "site"
        }
      ]
    };
  }
};
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=VT323&family=Share+Tech+Mono&display=swap');

*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.crt {
  height: 100vh;
  overflow: hidden;
  background-color: #0a0a0a;
  color: #33ff57;
  font-family: 'Share Tech Mono', 'Courier New', monospace;
  font-size: 16px;
  line-height: 1.7;
  position: relative;
  overflow-x: hidden;
}

/* Scanline overlay */
.crt::before {
  content: '';
  position: fixed;
  inset: 0;
  background: repeating-linear-gradient(
    to bottom,
    transparent 0px,
    transparent 3px,
    rgba(0, 0, 0, 0.08) 3px,
    rgba(0, 0, 0, 0.08) 4px
  );
  pointer-events: none;
  z-index: 10;
}

/* Vignette */
.crt::after {
  content: '';
  position: fixed;
  inset: 0;
  background: radial-gradient(ellipse at center, transparent 60%, rgba(0,0,0,0.55) 100%);
  pointer-events: none;
  z-index: 9;
}

.container {
  max-width: 680px;
  margin: 0 auto;
  padding: 5rem 2rem 4rem;
}

/* Header */
header {
  display: flex;
  align-items: baseline;
  gap: 0;
  margin-bottom: 0.5rem;
}

.prompt {
  color: #1a8c30;
  font-family: 'VT323', monospace;
  font-size: 2rem;
}

h1 {
  font-family: 'VT323', monospace;
  font-size: 2.8rem;
  font-weight: normal;
  letter-spacing: 0.05em;
  color: #33ff57;
}

.cursor {
  font-family: 'VT323', monospace;
  font-size: 2.8rem;
  color: #33ff57;
  animation: blink 1s step-end infinite;
  margin-left: 2px;
}

@keyframes blink {
  50% { opacity: 0; }
}

.tagline {
  color: #1a8c30;
  font-size: 0.95rem;
  margin-bottom: 3.5rem;
  letter-spacing: 0.03em;
}

/* Sections */
.block {
  margin-bottom: 2.5rem;
}

h2 {
  font-size: 0.85rem;
  color: #1a8c30;
  letter-spacing: 0.1em;
  margin-bottom: 0.75rem;
  font-weight: normal;
}

p {
  font-size: 0.95rem;
  color: #33ff57;
  line-height: 1.8;
}

/* Work rows */
.project-row {
  display: flex;
  align-items: baseline;
  gap: 0.6rem;
  margin-bottom: 0.3rem;
  font-size: 0.95rem;
}

.idx {
  color: #1a8c30;
  flex-shrink: 0;
}

.proj-name {
  color: #33ff57;
  white-space: nowrap;
}

.dots {
  flex: 1;
  border-bottom: 1px dotted #1a4a25;
  margin-bottom: 4px;
  min-width: 1rem;
}

.proj-link {
  flex-shrink: 0;
  text-decoration: none;
  color: #33ff57;
  font-size: 0.9rem;
}

.proj-link:hover {
  text-decoration: underline;
}

.dim {
  color: #1a4a25;
}

/* Contact */
.links {
  font-size: 0.95rem;
}

.links a {
  color: #33ff57;
  text-decoration: none;
}

.links a:hover {
  text-decoration: underline;
}

.sep {
  color: #1a4a25;
}

/* Mobile */
@media (max-width: 480px) {
  .container {
    padding: 3rem 1.25rem 3rem;
  }

  h1 {
    font-size: 2.2rem;
  }

  .cursor {
    font-size: 2.2rem;
  }

  .proj-name {
    white-space: normal;
  }
}
</style>
